"use client";

import ReactMarkdown from "react-markdown";

type Props = { content: string };

export default function MarkdownContent({ content }: Props) {
  return (
    <div className="opacity-90 text-[#333] [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-[#00c4ff]  [&_h1]:mt-6 [&_h1]:mb-4 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-[#00c4ff] [&_h2]:mt-5 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-[#00c4ff] [&_h3]:mt-4 [&_h3]:mb-2 [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_strong]:font-bold">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}
